import {
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingType,
    BymoPagePropsSpecialContentSettingMetadata,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';
import type {HideableValue} from '@wix/devzai-utils-common';
import {hideableValueCreateHidden} from '@wix/devzai-utils-common';
import {DoppeActionTypeCountdownStyle} from '../doppe-action-type-countdown/doppe-action-type-countdown';
import type {DoppeCountdownTimerConfig} from '../../client-server-common/types/doppe-countdown-settings';

export namespace DoppeActionTypeCountdownLock {

    export interface ActionSettings extends DoppeCountdownTimerConfig {
        buttonText: HideableValue<string>;
    }
}

function doppeLockActionTypeCountdownResolveDefaultTargetDate(): string {
    const future = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
    return future.toISOString().slice(0, 10);
}

export const doppeLockActionTypeCountdown = doppeActionTypeDefineMetadata<DoppeActionTypeCountdownLock.ActionSettings>({
    id: 'io.bymo.action/countdown-lock',
    resolveActionSettings: action => {

        const settings = action.settings as Partial<DoppeActionTypeCountdownLock.ActionSettings> & {
            targetDate?: string;
            targetTime?: string;
            timeZoneId?: string;
        };

        const {
            endDateTime: nestedEnd,
            targetDate: legacyDate,
            targetTime: legacyTime,
            timeZoneId: legacyZone,
            timerStyle = DoppeActionTypeCountdownStyle.Minimalist,
            buttonText = hideableValueCreateHidden(''),
        } = settings;

        return {
            endDateTime: {
                endDate: nestedEnd?.endDate || legacyDate || doppeLockActionTypeCountdownResolveDefaultTargetDate(),
                endTime: nestedEnd?.endTime ?? legacyTime ?? '12:00',
                timeZoneId: nestedEnd?.timeZoneId ?? legacyZone ?? 'UTC',
            },
            timerStyle: timerStyle,
            buttonText: buttonText,
        };
    },
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            endDateTime: BymoPagePropsSpecialContentSettingMetadata.ToBeConsidered,
            timerStyle: BymoPagePropsSpecialContentSettingMetadata.ToBeConsidered,
            buttonText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityActionButtonText),
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {
            buttonText: true,
        },
        bindableContentSettingsNames: {},
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    isLinkOpener: false,
    isLockAction: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
});
